import React from "react";
import ReactApexChart from "react-apexcharts";

const ResultByOpenChart = ({data}) => {

  const series = [
    {
      type: "bar",
      data:
        (data &&
        Object.keys(data).length &&
        Object.keys(data).map((day) => {
          return Number(data[day].close).toFixed(2);
        }))||[],
    },
  ];

  const options = {
    colors: ["#04D9FF"],
    fill: {
      colors: ["#04D9FF"],
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },

    plotOptions: {
      bar: {
        columnWidth: "80%",
        distributed: true,
        borderRadius: 8,
        colors: {
          ranges: [
            {
              from: 0,
              to: 2100,
              color: "#04D9FF",
            },
            {
              from: -1400,
              to: 0,
              color: "#FD504F",
            },
          ],
        },
      },
    },

    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "bar",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    xaxis: {
      seriesName: "Day",
      //   title: {
      //     text: "No. of trades",
      //     style: {
      //       fontSize: 14,
      //       fontWeight: 700,
      //       color: "#ffffff",
      //     },
      //   },
      categories: (data && Object.keys(data).length && Object.keys(data))||[],
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        seriesName: "Open Price",
        // title: {
        //   text: "Balance",
        //   style: {
        //     fontSize: 14,
        //     fontWeight: 700,
        //     color: "#ffffff",
        //   },
        // },
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },

      // type: 'datetime',
    ],
    tooltip: {
      enabled: false,
    },
  };

    return (
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          height={250}
        />
      </div>
    );
}
export default ResultByOpenChart;
